<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <b-card body-class="p-2" class="shadow-sm" border-variant="white">
              <h5 class="m-0">
                <i class="fas fa-file-invoice-dollar"></i> รายงานการเงิน
              </h5>
            </b-card>
          </b-col>
        </b-row>
        <div class="btn-group special mt-2 shadow-sm" role="group">
          <b-button
            type="button"
            :class="filter == 1 ? 'font-weight-bold active' : 'font-weight-bold'"
            variant="outline-secondary"
            @click="setFilter(1)"
          >
            <i class="far fa-clock"></i> วันนี้
          </b-button>
          <b-button
            type="button"
            :class="filter == 3 ? 'font-weight-bold active' : 'font-weight-bold'"
            variant="outline-secondary"
            @click="setFilter(3)"
          >
            <i class="fas fa-history"></i> ก่อนหน้า
          </b-button>
        </div>
        <b-row>
          <b-col class="text-secondary">
            <small>*คลิกที่รายการเพื่อดูรายละเอียดเพิ่มเติม</small>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="loading">
          <b-col class="text-center">
            <b-spinner variant="warning" type="grow" label="Loading"></b-spinner>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="statements.length == 0 && !loading">
          <b-col>
            <b-card body-class="p-2 text-center" class="shadow-sm" border-variant="white">
              <small class="text-secondary">ไม่มีรายการ</small>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="statements.length > 0 && !loading">
          <b-col cols="12" v-for="(item,index) in statements" v-bind:key="index" class="mb-2">
            <b-card
              body-class="pt-2 px-0 pb-0"
              class="shadow-sm item-card"
              border-variant="white"
              v-b-toggle="'toggle-' + item.id"
              footer-tag="footer"
              footer-class="p-0"
              footer-bg-variant="dark"
              footer-border-variant="light"
            >
              <template #footer>
                <b-collapse :id="'toggle-' + item.id">
                  <div class="p-2">
                    <b-row>
                      <b-col cols="6">
                        <b-badge>เลขที่รายการ #{{item.id}}</b-badge>
                      </b-col>
                      <b-col cols="6" class="text-right text-white">
                        <small>คงเหลือ</small>&nbsp;
                        <span class="text-info">฿ {{item.remainAmount}}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-light">
                        <small>หมายเหตุ: {{item.description ? item.description : '-'}}</small>
                      </b-col>
                    </b-row>
                  </div>
                </b-collapse>
              </template>
              <div class="px-2">
                <b-row>
                  <b-col cols="6">
                    <b-badge variant="warning">{{item.cashTypeText}}</b-badge>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <h5 class="mb-0">{{item.amountSign}} ฿ {{item.amount}}</h5>
                  </b-col>
                </b-row>
                <b-row class="pb-2">
                  <b-col cols="6">
                    <small v-if="item.amountSign == '-'">
                      {{getUsername}}
                      <i class="fas fa-chevron-right"></i>
                      ระบบ
                    </small>
                    <small v-if="item.amountSign == '+'">
                      ระบบ
                      <i class="fas fa-chevron-right"></i>
                      {{getUsername}}
                    </small>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <small>
                      <i class="far fa-clock"></i>
                      {{formatDate(item.createdDate, "DD/MM/YYYY HH:mm:ss")}}
                    </small>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  props: ["page"],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      loading: true,
      filter: 1,
      statements: []
    };
  },
  mounted() {
    this.getStatements();
  },
  methods: {
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    },
    setFilter(historicalDate) {
      if (this.filter != historicalDate && !this.loading) {
        this.loading = true;
        this.filter = historicalDate;
        this.getStatements();
      }
    },
    getStatements() {
      axios
        .post(
          this.getApiUrl + "/cash/getallcashflow",
          {
            username: this.getUsername,
            historicalDate: this.filter
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.loading = false;
          this.statements = response.data.data;
          console.log("get transaction", response);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.item-card {
  outline: none;
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.btn-group.special {
  display: flex;
}

.special .btn {
  flex: 1;
}

.card-bg {
  background-color: #d6d8db;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}

.active {
  background: radial-gradient(
      ellipse farthest-corner at right bottom,
      #fedb37 0%,
      #fdb931 8%,
      #9f7928 30%,
      #8a6e2f 40%,
      transparent 80%
    ),
    radial-gradient(
      ellipse farthest-corner at left top,
      #ffffff 0%,
      #ffffac 8%,
      #d1b464 25%,
      #5d4a1f 62.5%,
      #5d4a1f 100%
    );
  color: #ffffff !important;
  border: goldenrod 1px solid !important;
}
</style>